import { combineReducers } from 'redux'

import application from './application'
import order from './order'

export default combineReducers({ 
    application,
    order
})